const  assistedBooking = (id)=>{
    console.log("normal:",id);
    return fetch(`/shared/api/assistedBooking?text=${id}`).then((response) => response.json())
}


export default assistedBooking
